import { NgModule } from '@angular/core';
import { SearchByTagComponent } from './search-by-tag.component';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { FuseWidgetModule } from '../../../core/components/widget/widget.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DialogComponent } from './dialog/dialog.component';
import { DialogComponent1 } from './dialog1/dialog1.component';

const routes = [
  {
      path     : 'search-by-tag',
      component: SearchByTagComponent,
      canActivate: [AuthGuard,RoleGuard]
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    FuseWidgetModule,
    NgxChartsModule
  ],
  declarations: [
    SearchByTagComponent,
    DialogComponent,
    DialogComponent1
  ],
  providers: [
    AuthGuard,
    RoleGuard
  ],
  entryComponents: [DialogComponent,DialogComponent1]
})

export class SearchByTagModule { }
